/*# sourceMappingURL=delete-section-dialog.component-EEXPVIPW.css.map */
